import {Accordion, Modal} from "react-bootstrap";
import React, { useEffect, useState } from "react";
import {fetchIndeeProjects} from "../../utils/api/helpers/indee";
import ScreenerGrid from "./ScreenerGrid";
import netflixLogo from "../../Common/_assets/img/logo/netflix-logo-ribbon.png";

const ScreenerProjectList = ({ activeTitleName, displayScreenerProjectList, setDisplayScreenerProjectList, activeProjectKey, setActiveProjectKey, setUnauth, doLogout, loggingOut }) => {

    const [ loaded, setLoaded ] = useState( false ),
        [ projectLoaded, setProjectLoaded ] = useState( false ),
        [ projectCount, setProjectCount ] = useState( 0 ),
        [ projectList, setProjectList ] = useState( [] ),
        [ activeAccordion, setActiveAccordion ] = useState( [] ),
        [ projectHasVideos, setProjectHasVideos ] = useState( true );

    useEffect(() => {
        if(!loaded && displayScreenerProjectList) {
            fetchIndeeProjects()
                .then(result => {
                    setLoaded(true);
                    if (result.data.error && result.data.message.unauth) {
                        setDisplayScreenerProjectList(false);
                        setUnauth();
                    } else {
                        setProjectCount(result.data.count);
                        setProjectList(result.data.results);
                        let hasKey = result.data.results.some(item => {
                            return item.key === activeProjectKey
                        });
                        setProjectHasVideos(hasKey)
                        console.log('project list',result.data.results, hasKey, activeTitleName)
                    }
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ loaded, displayScreenerProjectList, activeProjectKey,activeTitleName ]);

    useEffect(() => {
            if(activeAccordion && !projectLoaded) {
                setProjectLoaded(true);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [ activeAccordion, projectLoaded ]);

    return (
        <>
            <Modal centered size={'xl'} show={ displayScreenerProjectList } onHide={ () => setDisplayScreenerProjectList(false) }>
                <Modal.Header>
                    <Modal.Title>
                        <div className={'d-flex align-items-center justify-content-center flex-fill'}>
                            <div className={'d-flex align-items-center justify-content-center pe-3'}>
                                <img src={netflixLogo} className="header__logo" alt="Netflix"
                                     style={{maxWidth: '15px'}}/>
                            </div>
                            <div className={'d-flex align-items-center justify-content-center'}>
                            <span className={''} style={{
                                fontSize: '14px',
                                fontWeight: '300',
                                color: '#aaa',
                            }}>FYC | Screeners</span>
                            </div>
                            <div className={'d-flex align-items-center justify-content-center ms-auto'}>
                                <span onClick={() => {
                                    doLogout()
                                }} className={''} style={{
                                    fontSize: '10px',
                                    textTransform: 'uppercase',
                                    fontWeight: '300',
                                    color: '#e50914',
                                    cursor: 'pointer'
                                }}>{loggingOut ? 'Logging out...' : 'Logout'}</span>

                                <span onClick={() => {
                                    setDisplayScreenerProjectList(false)
                                }} className={'mx-4'} style={{
                                    fontSize: '10px',
                                    textTransform: 'uppercase',
                                    fontWeight: '300',
                                    color: '#e50914',
                                    cursor: 'pointer'
                                }}>Exit Screeners</span>
                            </div>

                        </div>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {
                        loaded ?
                            (
                                (projectCount > 0 && projectHasVideos) ?
                                    (
                                        <>
                                            {
                                                projectList.map((p, i) => {
                                                    if (p.key===activeProjectKey) {
                                                        return <div key={i}>
                                                            <h3 className={'indee-project-title'}>{ p.name }</h3>
                                                            {
                                                                !projectLoaded ? <p>Loading...</p>
                                                                    : (
                                                                        <ScreenerGrid projectKey={p.key} projectName={p.name} />
                                                                    )
                                                            }
                                                        </div>
                                                    } else {
                                                        return null
                                                    }
                                                })
                                            }
                                        </>
                                    ) :
                                    <>
                                        {
                                            activeTitleName && !projectHasVideos ?

                                                <div className={'my-4'} style={{color:'#ccc'}}>
                                                    There are no screeners currently available for <strong>{activeTitleName}</strong>. Please
                                                    see below for your list of available Screeners.
                                                </div>

                                                : null
                                        }

                                        <Accordion defaultActiveKey={activeProjectKey ? activeProjectKey : null}
                                                   onSelect={e => {
                                                       setActiveAccordion(e);
                                                       setProjectLoaded(false);
                                                   }}>
                                            {
                                                projectCount > 0 ?
                                                    (
                                                        <>
                                                            {
                                                                projectList.map((p, i) => {
                                                                    return <Accordion.Item eventKey={ p.key } key={ i }>
                                                                        <Accordion.Header>{ p.name }</Accordion.Header>
                                                                        <Accordion.Body>
                                                                            {
                                                                                !projectLoaded ? <p>Loading...</p>
                                                                                    : (
                                                                                        <ScreenerGrid projectKey={p.key} projectName={p.name} />
                                                                                    )
                                                                            }
                                                                        </Accordion.Body>
                                                                    </Accordion.Item>
                                                                })
                                                            }
                                                        </>
                                                    ) : <li>You do not have any Screeners available at this time.</li>
                                            }
                                        </Accordion>
                                    </>
                            ) : <p>Loading...</p>
                    }
                </Modal.Body>
                <Modal.Footer/>
            </Modal>

        </>
    );
}

export default ScreenerProjectList;
